import React from 'react';
import { NotificationDataType } from './common/types';

export class AppContextType {
  constructor(params: AppContextType) {
    this.notificationData = params.notificationData;
    this.setNotificationData = params.setNotificationData;
  }

  notificationData: NotificationDataType | undefined;

  setNotificationData: React.Dispatch<React.SetStateAction<NotificationDataType | undefined>>;
}

const AppContext = React.createContext<AppContextType | null>(null);

export default AppContext;
